import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody } from '@/utils'

export default {
    fetch() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRuleTemplates {
                        id
                        name,
                        channel,
                        message,
                        relationshipRule {
                            id,
                            name
                        },
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    fetchWhere(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRuleTemplates (
                        id: ${id},
                    ) {
                        id
                        name,
                        channel,
                        channel_number,
                        message,
                        senderEmail {
                            id,
                            email
                        },
                        sender_name,
                        subject,
                        relationshipRule {
                            id,
                            name
                        },
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    update(id, data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    updateRuleTemplate (
                        id: ${id},
                        message: "${data.message}",
                        name: "${data.name}",
                        relationship_rule_id: ${data.relationship_rule_id},
                        channel: ${data.channel},
                        sender_name: ` + (data.sender_name !== undefined && data.sender_name !== null ? `"${data.sender_name}"` : null) + `,
                        selected_sender_id: ` + (data.selected_sender_id !== undefined && data.selected_sender_id !== null ? `${data.selected_sender_id}` : null) + `,
                        subject: ` + (data.subject !== undefined && data.subject !== null ? `"${data.subject}"` : null) + `
                    ) {
                        id
                        name,
                        channel,
                        message,
                        relationshipRule {
                            id,
                            name
                        },
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    create(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    createRuleTemplate (
                        message: "${data.message}",
                        name: "${data.name}",
                        relationship_rule_id: ${data.relationship_rule_id},
                        channel: ${data.channel},
                        sender_name: ` + (data.sender_name !== undefined && data.sender_name !== null ? `"${data.sender_name}"` : null) + `,
                        selected_sender_id: ` + (data.selected_sender_id !== undefined && data.selected_sender_id !== null ? `${data.selected_sender_id}` : null) + `,
                        subject: ` + (data.subject !== undefined && data.subject !== null ? `"${data.subject}"` : null) + `
                    ) {
                        id
                        name,
                        channel,
                        message,
                        relationshipRule {
                            id,
                            name
                        },
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    delete(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteRuleTemplate (
                        id: ${id}
                    )
                }
            `
        })
    },

    fetchPaginated: (sortName = "id", page, itemsPerPage, type = "ASC", word = "") => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', formatGraphqlBody(
          'query',
          'getRuleTemplatePaginated',
          {
            0: 'pagination_page',
            1: 'pagination_limit',
            2: 'total_pages',
            3: 'total_items',
            items: {
              0: 'id',
              1: 'name',
              2: 'channel',
              3: 'message',
              4: 'relationship_rule_id',
              5: 'event_type',
              relationshipRule: {
                0: 'id',
                1: 'name'
              }
            }
          },
          {
            orderBy: [sortName, type],
            search_filter: word,
            pagination_page: page,
            pagination_limit: itemsPerPage
          }
        ));
      },
}